module.exports = __webpack_public_path__ + "img/Developer.ee7534ae.svg";